import React from 'react';
import classNames from 'classnames';
import { Shimmer } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getPerformanceShimmerStyle } from './styles/get-performance-shimmer-styles';

export function PerformanceShimmer() {
  const classes = useDefaultStyles(getPerformanceShimmerStyle);
  return (
    <div className={classNames('performance-shimmer', classes.shimmerContainer)}>
      <Shimmer width={293} className={classes.shimmerStyle} />
      <Shimmer width={254} className={classes.shimmerStyle} />
      <Shimmer width={293} className={classes.shimmerStyle} />
    </div>
  );
}
